import { render } from "./EditPointVentePage.vue?vue&type=template&id=01a200c2&ts=true"
import script from "./EditPointVentePage.vue?vue&type=script&lang=ts"
export * from "./EditPointVentePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__